import { useSelector } from 'react-redux';

export default function useUserInfo() {
    return useSelector(state => state.userInfo);
}